/** Native saved paths are absolute. Encode each segment so a literal percent
 * escape, hash or question mark cannot change which local file is opened. */
export function screenRecordingFileUrl(path: string): string {
  const windows = /^[A-Za-z]:[\\/]/.test(path) || path.startsWith("\\\\");
  const normalized = windows ? path.replace(/\\/g, "/") : path;
  const encode = (value: string) =>
    value.split("/").map(encodeURIComponent).join("/");
  if (normalized.startsWith("//")) {
    const [host, ...segments] = normalized.slice(2).split("/");
    return `file://${host}/${encode(segments.join("/"))}`;
  }
  if (/^[A-Za-z]:\//.test(normalized))
    return `file:///${normalized.slice(0, 2)}${encode(normalized.slice(2))}`;
  if (normalized.startsWith("/")) return `file://${encode(normalized)}`;
  throw new Error("The saved recording path is not absolute.");
}
